import { render, staticRenderFns } from "./InspectionPersonnel.vue?vue&type=template&id=f16db9e0&scoped=true"
import script from "./InspectionPersonnel.vue?vue&type=script&lang=js"
export * from "./InspectionPersonnel.vue?vue&type=script&lang=js"
import style0 from "./InspectionPersonnel.vue?vue&type=style&index=0&id=f16db9e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16db9e0",
  null
  
)

export default component.exports